// A plain success-or-failure value, used wherever domain code has to accept input a
// person typed. The failure carries a stable code, not a sentence: the API turns codes
// into messages (`{ error: { code, message } }`, CLAUDE.md API conventions) and the web
// app can translate them.
//
// The boundary is deliberate. Anything that parses user input returns a `Result`.
// Anything that operates on values the domain has already validated (adding two amounts
// in the same currency, formatting a normalised phone number) throws on misuse, because
// reaching it with a bad value is a programming error, not something a receptionist did.

export interface Ok<T> {
  readonly ok: true;
  readonly value: T;
}

export interface Err<C extends string> {
  readonly ok: false;
  readonly code: C;
}

export type Result<T, C extends string> = Ok<T> | Err<C>;

export function ok<T>(value: T): Ok<T> {
  return { ok: true, value };
}

export function err<C extends string>(code: C): Err<C> {
  return { ok: false, code };
}
